import type { FacetComponentProps } from 'components/search/FacetAccordion/FacetAccordion.types';
import { Radio } from 'components/common/Radio/Radio';
import { getTestId } from 'utils/testing';

export const RadioFacet = (props: Extract<FacetComponentProps, { type: 'radio' }>) => {
  const { label, count, isSelected, onClick, name, value, testId } = props;
  return (
    <Radio checked={isSelected} readOnly onClick={onClick} name={name} value={value} label={label} data-test-id={getTestId(testId)}>
      <span className="body-xs ml-auto text-gray-500">{`(${count})`}</span>
    </Radio>
  );
};
